// extracted by mini-css-extract-plugin
export default {"title":"view_title__8h0V0","container":"view_container__kDoyT","teamContainer":"view_teamContainer__6hHUu"};